import { Col, Form, Input, Row, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntAgroculturalCooperative } from "../../../../models/mechanization/agroculturalCooperative";
import SelectEntityTypes from "../../../../components/selects/SelectEntityTypes";
import { GeoJsonPoint, Geometry } from "../../../../models/geoJsonPoint";
import { MapAddSingleMarker } from "../../../../components/maps/MapAddPoint";
import { SelectEconomicActivityTypes, SelectYear } from "../../../../components/selects";
import SelectTerritorialUnitsCode from "../../../../components/selects/SelectTerritorialUnitsCode";

enum FormField {
  id, // Идентификатор
  codeOkpo, // Код ОКПО
  name, // Наименование

  legalRegionId,
  legalAreaId,
  legalAddressTerritorialUnitId,

  legalAddressZipCode, // Почтовый индекс юридического адреса
  legalAddress, // Юридический адрес в текстовом представлении

  actualRegionId,
  actualAreaId,
  actualAddressTerritorialUnitId, // ID COATE фактического адреса

  actualAddressZipCode, // Почтовый индекс фактического адреса
  actualAddress, // Фактический адрес в текстовом представлении
  managerFullName, // ФИО руководителя
  email, // Электронная почта
  phoneNumber, // Номер телефона
  legalFormId, // ID организационно-правовой формы
  typeEconomicActivityId, // ID вида экономической деятельности
  longitude, // Долгота
  latitude, // Широта
  year // год
}

interface IProps {
  show: boolean;
  agroculturalCooperative: EntAgroculturalCooperative;
  onHide: () => void;
  onSubmit: (pos: EntAgroculturalCooperative) => Promise<boolean>;
}

export const AddAgroculturalCooperativeModal = (props: IProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [geoJsonData, setGeoJsonData] = useState<GeoJsonPoint|null>(null);
  const [selectedRegionPolygonJson, setSelectedRegionPolygonJson] = useState<string | null>(null);

  const [selectedLegalRegionId, setSelectedLegalRegionId] = useState<number | null>(null);
  const [selectedLegalRegionCode, setSelectedLegalRegionCode] = useState<string | null>(null);
  const [selectedLegalAreaCode, setSelectedLegalAreaCode] = useState<string | null>(null);
  const [selectedLegalAreaId, setSelectedLegalAreaId] = useState<number | null>(null);

  const [selectedActualRegionId, setSelectedActualRegionId] = useState<number | null>(null);
  const [selectedActualRegionCode, setSelectedActualRegionCode] = useState<string | null>(null);
  const [selectedActualAreaCode, setSelectedActualAreaCode] = useState<string | null>(null);
  const [selectedActualAreaId, setSelectedActualAreaId] = useState<number | null>(null);

  const { Text } = Typography;

  useEffect(() => {
	if (props.show) setFieldsFromEntity();
	setSelectedLegalRegionId(props.agroculturalCooperative.legalAddressTerritorialUnitRegion?.id || null);
	setSelectedLegalAreaId(props.agroculturalCooperative.legalAddressTerritorialUnitArea?.id || null);
	setSelectedLegalAreaCode(props.agroculturalCooperative.legalAddressTerritorialUnitArea?.code || null);

	setSelectedActualRegionId(props.agroculturalCooperative.actualAddressTerritorialUnitRegion?.id || null);
	setSelectedActualAreaId(props.agroculturalCooperative.actualAddressTerritorialUnitArea?.id || null);
	setSelectedActualAreaCode(props.agroculturalCooperative.actualAddressTerritorialUnitArea?.code || null);
  }, [props.show]);

  const setFieldsFromEntity = (): void => {
	form.setFields([
	  { name: FormField.year, value: props.agroculturalCooperative.year },
	  { name: FormField.codeOkpo, value: props.agroculturalCooperative.codeOkpo },
	  { name: FormField.name, value: props.agroculturalCooperative.name },

	  { name: FormField.legalRegionId, value: props.agroculturalCooperative.legalAddressTerritorialUnitRegion?.id },
	  { name: FormField.legalAreaId, value: props.agroculturalCooperative.legalAddressTerritorialUnitArea?.id },
	  {
		name: FormField.legalAddressTerritorialUnitId,
		value: props.agroculturalCooperative.legalAddressTerritorialUnit?.id
	  },

	  { name: FormField.legalAddressZipCode, value: props.agroculturalCooperative.legalAddressZipCode },
	  { name: FormField.legalAddress, value: props.agroculturalCooperative.legalAddress },

	  { name: FormField.actualRegionId, value: props.agroculturalCooperative.actualAddressTerritorialUnitRegion?.id },
	  { name: FormField.actualAreaId, value: props.agroculturalCooperative.actualAddressTerritorialUnitArea?.id },
	  {
		name: FormField.actualAddressTerritorialUnitId,
		value: props.agroculturalCooperative.actualAddressTerritorialUnit?.id
	  },

	  { name: FormField.actualAddressZipCode, value: props.agroculturalCooperative.actualAddressZipCode },
	  { name: FormField.actualAddress, value: props.agroculturalCooperative.actualAddress },
	  { name: FormField.managerFullName, value: props.agroculturalCooperative.managerFullName },
	  { name: FormField.email, value: props.agroculturalCooperative.email },
	  { name: FormField.phoneNumber, value: props.agroculturalCooperative.phoneNumber },
	  { name: FormField.legalFormId, value: props.agroculturalCooperative.legalForm?.id },
	  { name: FormField.typeEconomicActivityId, value: props.agroculturalCooperative.typeEconomicActivity?.id },

	]);
  };
  const updateGeoJsonPoint = () => {
	const latitude = props.agroculturalCooperative.latitude;
	const longitude = props.agroculturalCooperative.longitude;

	if (latitude !== undefined && longitude !== undefined) {
	  const geoJsonPoint = new GeoJsonPoint();
	  geoJsonPoint.geometry = new Geometry();
	  geoJsonPoint.geometry.coordinates = [longitude, latitude];
	  setGeoJsonData(geoJsonPoint);
	} else {
	  console.error(t('breeding_farms.error_geometry'));
	}
  };
  useEffect(() => {
	if (props.agroculturalCooperative.latitude && props.agroculturalCooperative.longitude) {
	  updateGeoJsonPoint();
	} else {
	  setGeoJsonData(null)
	}
  }, [props.agroculturalCooperative.latitude, props.agroculturalCooperative.longitude]);
  const setEntityFromFields = (): EntAgroculturalCooperative => {
	let res = _.cloneDeep(props.agroculturalCooperative);
	res.codeOkpo = form.getFieldValue(FormField.codeOkpo);
	res.year = form.getFieldValue(FormField.year);
	res.name = form.getFieldValue(FormField.name);

	res.legalRegionId = form.getFieldValue(FormField.legalRegionId);
	res.legalAreaId = form.getFieldValue(FormField.legalAreaId);
	res.legalAddressTerritorialUnitId = form.getFieldValue(FormField.legalAddressTerritorialUnitId);

	res.legalAddressZipCode = form.getFieldValue(FormField.legalAddressZipCode);
	res.legalAddress = form.getFieldValue(FormField.legalAddress);

	res.actualRegionId = form.getFieldValue(FormField.actualRegionId);
	res.actualAreaId = form.getFieldValue(FormField.actualAreaId);
	res.actualAddressTerritorialUnitId = form.getFieldValue(FormField.actualAddressTerritorialUnitId);

	res.actualAddressZipCode = form.getFieldValue(FormField.actualAddressZipCode);
	res.actualAddress = form.getFieldValue(FormField.actualAddress);
	res.managerFullName = form.getFieldValue(FormField.managerFullName);
	res.phoneNumber = form.getFieldValue(FormField.phoneNumber);
	res.legalFormId = form.getFieldValue(FormField.legalFormId);
	res.typeEconomicActivityId = form.getFieldValue(FormField.typeEconomicActivityId);
	res.email = form.getFieldValue(FormField.email);
	if (geoJsonData !== null) {
	  res.latitude = geoJsonData.geometry?.coordinates[1] as number;
	  res.longitude = geoJsonData.geometry?.coordinates[0] as number;
	}
	return res;
  };

  const hideModal = () => {
	props.onHide();
	setSelectedLegalRegionId(null);
	setSelectedLegalAreaCode(null);

	setSelectedActualRegionId(null);
	setSelectedActualAreaCode(null);

	setSelectedRegionPolygonJson(null);

	setGeoJsonData(null);
  };

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  const data = setEntityFromFields();
	  const result = await props.onSubmit(data);
	  if (result) hideModal();
	} finally {
	  setLoading(false);
	}
  };

  return (
	<>
	  <DraggableModal
		title={ props.agroculturalCooperative.id === null ? t('mechanisation.agricultural_cooperative.add_agricultural_cooperative') : t('mechanisation.agricultural_cooperative.edit_agricultural_cooperative') }
		visible={ props.show }
		onCancel={ () => {
		  hideModal()
		} }
		onSubmit={ handleSubmit }
		submitLoading={ loading }
		width={ 1000 }
	  >
		<Form
		  initialValues={ { remember: true } }
		  autoComplete="off"
		  layout="vertical"
		  form={ form }
		>
		  <Row gutter={ 10 }>
			<Col style={ { marginBottom: 20 } } span={ 24 }>
			  <MapAddSingleMarker
				polygonJson={ selectedRegionPolygonJson }
				setGeoJsonData={ setGeoJsonData }
				geoJsonData={ geoJsonData }
			  />
			</Col>
		  </Row>
		  <div className="block_item_form">
			<Text underline strong>Основная информация</Text>

			<Row gutter={ 10 }>
			  <Col span={ 8 }>
				<Form.Item
				  label={ t('mechanisation.agricultural_cooperative.name_object') }
				  name={ FormField.name }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <Input type="text"/>
				</Form.Item>
			  </Col>
			  <Col span={ 8 }>
				<Form.Item
				  label={ t('mechanisation.agricultural_cooperative.okp_code_cooperative') }
				  name={ FormField.codeOkpo }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <Input type="text"/>
				</Form.Item>
			  </Col>
			  <Col span={ 8 }>
				<Form.Item
				  label={ t('general.year') }
				  name={ FormField.year }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <SelectYear/>
				</Form.Item>
			  </Col>
			</Row>
		  </div>
		  <Row gutter={ 10 }>
			<Col span={ 12 }>
			  <div className="block_item_form">
				<Text underline strong>Юридический адрес</Text>
				<Form.Item
				  label={ t('titles.territorial_unit_area') }
				  name={ FormField.legalRegionId }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <SelectTerritorialUnitsCode
					parentId={ 1 }
					onChange={ (value, option: any) => {
					  setSelectedLegalRegionId(Number(value));
					  setSelectedLegalRegionCode(option?.data?.code);
					  setSelectedLegalAreaCode(null);
					  setSelectedLegalAreaId(null);
					  form.setFieldsValue({
						[FormField.legalRegionId]: value,
						[FormField.legalAreaId]: null, // Сбрасываем район
						[FormField.legalAddressTerritorialUnitId]: null, // Сбрасываем населенный пункт
					  });
					} }
				  />
				</Form.Item>
				  <>
				{ selectedLegalRegionId || props.agroculturalCooperative.legalAddressTerritorialUnitRegion ? (
				  <Form.Item
					label={ t('titles.territorialUnitDistricts') }
					name={ FormField.legalAreaId }
					rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				  >
					<SelectTerritorialUnitsCode
					  type={ ['AREA'] }
					  parentId={ selectedLegalRegionId }
					  onChange={ (value, option: any) => {
						setSelectedLegalAreaCode(option?.data?.code || null);
						setSelectedLegalAreaId(value as number);
						form.setFields([{ name: FormField.legalAddressTerritorialUnitId, value: null }]);
					  } }
					/>
				  </Form.Item>
				) : null }

				{ selectedLegalAreaCode || props.agroculturalCooperative.legalAddressTerritorialUnit ? (
				  <Form.Item
					label={ t("titles.territorialUnitVillage") }
					name={ FormField.legalAddressTerritorialUnitId }
					rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				  >
					<SelectTerritorialUnitsCode areaCode={ selectedLegalAreaCode }/>
				  </Form.Item>
				) : null }
				  </>
				<Form.Item
				  label={ t('mechanisation.agricultural_cooperative.postal_code_legal_address') }
				  name={ FormField.legalAddressZipCode }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <Input type="text"/>
				</Form.Item>

				<Form.Item
				  label={ t('mechanisation.agricultural_cooperative.legal_address') }
				  name={ FormField.legalAddress }
				>
				  <Input type="text"/>
				</Form.Item>

			  </div>
			</Col>
			<Col span={ 12 }>
			  <div className="block_item_form">
				<Text underline strong>Фактический адрес</Text>
				<Form.Item
				  label={ t('titles.territorial_unit_area') }
				  name={ FormField.actualRegionId }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <SelectTerritorialUnitsCode
					parentId={ 1 }
					onChange={ (value, option: any) => {
					  setSelectedActualRegionId(Number(value));
					  setSelectedRegionPolygonJson(option?.data?.polygonJson);
					  setSelectedActualRegionCode(option?.data?.code);
					  setSelectedActualAreaCode(null);
					  setSelectedActualAreaId(null);
					  form.setFieldsValue({
						[FormField.actualRegionId]: value,
						[FormField.actualAreaId]: null, // Сбрасываем район
						[FormField.actualAddressTerritorialUnitId]: null, // Сбрасываем населенный пункт
					  });
					} }
				  />
				</Form.Item>
				  <>
				{ selectedActualRegionId || props.agroculturalCooperative.actualAddressTerritorialUnitRegion ? (
				  <Form.Item
					label={ t('titles.territorialUnitDistricts') }
					name={ FormField.actualAreaId }
					rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				  >
					<SelectTerritorialUnitsCode
					  type={ ['AREA'] }
					  parentId={ selectedActualRegionId }
					  onChange={ (value, option: any) => {
						setSelectedRegionPolygonJson(option?.data?.polygonJson);
						setSelectedActualAreaCode(option?.data?.code || null);
						setSelectedActualAreaId(value as number);
						form.setFields([{ name: FormField.actualAddressTerritorialUnitId, value: null }]);
					  } }
					/>
				  </Form.Item>
				) : null }

				{ selectedActualAreaCode || props.agroculturalCooperative.actualAddressTerritorialUnit ? (
				  <Form.Item
					label={ t("titles.territorialUnitVillage") }
					name={ FormField.actualAddressTerritorialUnitId }
					rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				  >
					<SelectTerritorialUnitsCode areaCode={ selectedActualAreaCode }/>
				  </Form.Item>
				) : null }
				  </>
				<Form.Item
				  label={ t('mechanisation.agricultural_cooperative.postal_code_actual_address') }
				  name={ FormField.actualAddressZipCode }
				>
				  <Input type="text"/>
				</Form.Item>
				<Form.Item
				  label={ t('mechanisation.agricultural_cooperative.actual_address') }
				  name={ FormField.actualAddress }
				>
				  <Input type="text"/>
				</Form.Item>
			  </div>
			</Col>

		  </Row>

		  <div className="block_item_form">

			<Row gutter={ 10 }>
			  <Col span={ 12 }>
				<Form.Item
				  label={ t('mechanisation.agricultural_cooperative.id_type_legal_entity') }
				  name={ FormField.legalFormId }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <SelectEntityTypes/>
				</Form.Item>


			  </Col>
			  <Col span={ 12 }>

				<Form.Item
				  label={ t('mechanisation.agricultural_cooperative.identifier_type_economic_activity') }
				  name={ FormField.typeEconomicActivityId }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <SelectEconomicActivityTypes/>
				</Form.Item>
			  </Col>
			</Row>
		  </div>
		  <div className="block_item_form">

			<Row gutter={ 10 }>
			  <Col span={ 12 }>
				<Form.Item
				  label={ t('mechanisation.agricultural_cooperative.supervisor_full_name') }
				  name={ FormField.managerFullName }
				  rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
				>
				  <Input/>
				</Form.Item>
				<Form.Item
				  label={ t('user.phone_number') }
				  name={ FormField.phoneNumber }
				  rules={ [
					{
					  required: true,
					  message: t("fill_in_the_field")
					},
					{
					  pattern: /^996\d{9}$/,
					  message: t('user.phone_number_desc')
					},
				  ] }
				>
				  <Input count={ {
					show: true,
					max: 12,
				  } } maxLength={ 12 } placeholder="996777000000" type="number" autoComplete="off"/>
				</Form.Item>
			  </Col>
			  <Col span={ 12 }>

				<Form.Item
				  label={ t('user.email') }
				  name={ FormField.email }
				>
				  <Input type="email"/>
				</Form.Item>
			  </Col>
			</Row>
		  </div>

		</Form>
	  </DraggableModal>
	</>
  );
};
